import { createReducer, on } from '@ngrx/store';
import { initialUiState } from '../states/ui.state';
import { UiActions } from '../actions/ui.actions';

export const uiReducer = createReducer(
  initialUiState,
  on(UiActions.sidebarToggle, state => ({ ...state, sidebarVisible: !state.sidebarVisible })),
  on(UiActions.sidebarHideMobile, state => ({ ...state, sidebarVisible: window.screen.width < 960 ? false : state.sidebarVisible })),
);